import { ComponentFactoryResolver, Directive, Input } from '@angular/core';

import { CieUtilsModalManagerService } from '@cakeiteasy/web-utils';

import { UiFullSizeImageComponent } from '../modals/ui-full-size-image/ui-full-size-image.component';

@Directive({
  standalone: false,
  selector: '[imagePreviewTrigger]',
  host: {
    '(click)': 'openPreview($event)',
    '[attr.role]': 'imagePreviewTrigger ? "button" : null',
    '[attr.tabindex]': 'imagePreviewTrigger ? "0" : null',
    '[attr.aria-haspopup]': 'imagePreviewTrigger ? "dialog" : null',
    '[class.pointer]': '!!imagePreviewTrigger'
  }
})
export class ImagePreviewTriggerDirective {
  @Input() imagePreviewTrigger: string;

  constructor(private _modalManagerService: CieUtilsModalManagerService,
              private _componentResolver: ComponentFactoryResolver) {
  }

  public openPreview(event?: Event): void {
    if (!this.imagePreviewTrigger) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    this._modalManagerService
      .show(UiFullSizeImageComponent, this._componentResolver, { imgUrl: this.imagePreviewTrigger }, {
        windowClass: 'full-size-image-modal',
      })
      .catch(() => {
      });
  }
}
